export default {"src":"/_next/static/media/icon_nav_dd_about_off.a2385ee9.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};